import styles from './RecommendationPage.module.scss';

type PlanYearToggleProps = {
  years: string[];
  selectedYear: string;
  onChange: (year: string) => void;
};

const PlanYearToggle = ({
  years,
  selectedYear,
  onChange,
}: PlanYearToggleProps) => {
  if (years.length <= 1) {
    return null;
  }

  return (
    <fieldset className={styles.planYearToggle}>
      <legend className={styles.planYearLabel}>Plan Year</legend>

      <form className={styles.toggleSwitch}>
        {years.map((year) => {
          return (
            <label key={year} className={styles.toggleOption}>
              <input
                type="radio"
                name="year"
                value={year}
                checked={selectedYear === year}
                onChange={() => onChange(year)}
              />
              <span>{year}</span>
            </label>
          );
        })}
      </form>
    </fieldset>
  );
};

export default PlanYearToggle;
